export const PAYMENT_CONTEXT_FAST_TOP_UP = "fastTopUp";
export const PAYMENT_CONTEXT_PREORDER = "preorder";
export const PAYMENT_CONTEXT_TOP_UP = "topUp";
// This is for the specific case of top-up to complete the balance with the missing amount to pay preorder cart.
export const PAYMENT_CONTEXT_TOP_UP_PREORDER = "topUpPreorder";

export const PaymentStatus = {
  ABORTED: "A",
  VALIDATED: "V",
  WAITING: "W",
};

export const TopUpStatus = {
  VALIDATED: "V",
  WAITING: "W",
};
